class HeaderBar extends HTMLElement {
  constructor() {
    super();
    this.innerHTML = `
      <header>
        <div class="header-left">
          <button id="menuBtn" class="menu-btn" aria-label="Toggle menu">☰</button>
        </div>
        <div class="header-center">
          <h1 class="logo">NOTES APP <span class="logo">📓</span></h1>
        </div>
      </header>
    `;
  }

  connectedCallback() {
    const btn = this.querySelector("#menuBtn");
    const setIcon = (isCollapsed) => {
      btn.textContent = isCollapsed ? '☰' : '✖';
      btn.setAttribute('aria-expanded', String(!isCollapsed));
      btn.setAttribute('aria-label', isCollapsed ? 'Open sidebar' : 'Close sidebar');
    };

    setIcon(document.body.classList.contains('sidebar-collapsed'));

    btn.addEventListener("click", () => {
      const collapsed = document.body.classList.toggle("sidebar-collapsed");
      setIcon(collapsed);
    });
  }
}

customElements.define("header-bar", HeaderBar);
